import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityActionsProps {
  children: React.ReactNode;
  className?: string;
}

export const ActivityActions: React.FC<ActivityActionsProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn('ml-13 mt-2 flex items-center gap-4', className)}>
      {children}
    </div>
  );
};
